/** TR primary, EN secondary. Copy lives inline as (tr, en) pairs so the Turkish source stays readable. */
import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import type { Lang } from '../../../src/domain/time';

const KEY = 'gise.lang';
const initial = (): Lang => {
  try {
    const q = new URLSearchParams(location.search).get('lang');
    if (q === 'en' || q === 'tr') return q;
    const s = localStorage.getItem(KEY);
    if (s === 'en' || s === 'tr') return s;
  } catch {
    /* storage blocked */
  }
  return 'tr';
};

interface Ctx {
  lang: Lang;
  setLang: (l: Lang) => void;
  tx: (tr: string, en: string) => string;
}
const LangCtx = createContext<Ctx>({ lang: 'tr', setLang: () => {}, tx: (tr) => tr });

export function LangProvider({ children }: { children: ReactNode }) {
  const [lang, setLangState] = useState<Lang>(initial);
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
  const setLang = (l: Lang) => {
    setLangState(l);
    try {
      localStorage.setItem(KEY, l);
    } catch {
      /* ignore */
    }
  };
  return <LangCtx.Provider value={{ lang, setLang, tx: (tr, en) => (lang === 'en' ? en : tr) }}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);

export function LangToggle() {
  const { lang, setLang } = useLang();
  return (
    <button type="button" className="langbtn" onClick={() => setLang(lang === 'tr' ? 'en' : 'tr')} aria-label={lang === 'tr' ? 'Switch to English' : 'Türkçeye geç'}>
      {lang === 'tr' ? 'EN' : 'TR'}
    </button>
  );
}

export const KIND_EN: Record<string, string> = { Tiyatro: 'Theatre', 'Stand-up': 'Stand-up', Konser: 'Concert', Çocuk: 'Kids', Tümü: 'All' };
